const { REACT_APP_GOOGLE_CLIENT_ID, REACT_APP_STORY_D_BASE_URL } = process.env;

export const GOOGLE_CLIENT_ID: string = REACT_APP_GOOGLE_CLIENT_ID || "";
export const STORY_D_BASE_URL: string = REACT_APP_STORY_D_BASE_URL || "";